import { useState } from 'react';
import './CardColumn.css';

export default function CardColumn({ title, category, color, cards, sessionId, authorName }) {
  const [text, setText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!text.trim() || !authorName.trim()) return;
    setSubmitting(true);
    try {
      await fetch(`/api/sessions/${sessionId}/cards`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ author: authorName, category, content: text.trim() }),
      });
      setText('');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="column" style={{ '--column-color': color }}>
      <div className="column-header">
        <span className="column-dot" />
        <h2 className="column-title">{title}</h2>
        <span className="column-count">{cards.length}</span>
      </div>

      <form className="column-form" onSubmit={handleSubmit}>
        <textarea
          className="column-textarea"
          placeholder={authorName ? `Add a ${title.toLowerCase()} card…` : 'Enter your name above first'}
          value={text}
          onChange={(e) => setText(e.target.value)}
          disabled={!authorName || submitting}
          rows={3}
        />
        <button
          className="column-submit"
          type="submit"
          disabled={!text.trim() || !authorName || submitting}
        >
          {submitting ? 'Adding…' : 'Add card'}
        </button>
      </form>

      <div className="column-cards">
        {cards.map((card) => (
          <div key={card.id} className="retro-card-item">
            <p className="retro-card-content">{card.content}</p>
            <span className="retro-card-author">{card.author}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
